import {WebHelpers} from "../utils/WebHelpers";
import {AppConfig} from "../JqueryApp";

export const enum PaymentTrackingAction {
    PaymentTrackingActionUnknown = 0,
    PaymentTrackingActionAttempt = 1,
    PaymentTrackingActionError = 2,
    PaymentTrackingActionSuccess = 3,
    PaymentTrackingActionCancel = 4,
    PaymentTrackingActionInput = 5,
    PaymentTrackingActionUserAction = 6,
    PaymentTrackingActionAuth = 7,
}

export class CardEvent {
    protected static webHelpers: WebHelpers;
    protected static config: AppConfig;
    protected static autoSend: boolean = true;

    public readonly action: PaymentTrackingAction;
    public readonly time: Date;
    protected message: string = "";

    constructor(action: PaymentTrackingAction, message: string = "") {
        this.action = action;
        this.message = message;
        this.time = new Date();
        if (CardEvent.autoSend === true)
            this.send();
    }

    public static setWebHelpers(webHelpers: WebHelpers, config: AppConfig): void {
        CardEvent.webHelpers = webHelpers;
        CardEvent.config = config;
    }

    public static setAutoSend(autoSend: boolean): void {
        CardEvent.autoSend = autoSend;
    }

    public setMessage(message: string): CardEvent {
        this.message = message;
        return this;
    }

    public send(): void {
        try {
            const config = CardEvent.config;
            const url = config.apiBase + config.pathCardEvent;
            const fullToken = config.payment.token + "-" + config.payment.merchantId;
            const data = {
                tx_id: fullToken,
                action: this.action,
                message: this.message,
                time: this.time,
            }
            CardEvent.webHelpers.postApi(url, data, (data) => {
                if (!data || data.error) {
                    console.error("Error sending card event", data);
                    return;
                }
            });
        }
        catch (err) {
            console.error("Exception on card event", err);
        }
    }

    // ################################################################
    // ###################### PRIVATE FUNCTIONS #######################
}
